
import {  db } from '../../firebase.js';
import { doc, getDoc } from 'firebase/firestore';
import fetchPFP from '../fetchPFP.js';
import fetchBGP from '../fetchBGP.js';


export class ProfilePage {
    constructor(uid) {
        // this.user = user;
        this.userData = null;
        this.uid = uid;
        this.bio = null;
        this.genres = null;
        this.pronouns = null;
        this.username= null;
        this.profile_picture = null;
        this.background_picture = null;
        this.followersCount=null;
        this.followingCount=null;
        this.followers=null;
        this.following=null;
        this.isFollowing = null;
    }
    
    // getUser(){
    //     console.log(this.user);
    // }
    getUID(){
        console.log(this.uid);
    }

    getUserData(){
        console.log("printing user data: ",this.userData);
        return this.userData;
    }
    getBio(){
        console.log("printing bio: ",this.bio);
        return this.bio;
    }

    getGenres(){
        console.log("printing genres: ",this.genres);
        return this.genres;
    }

    getPronouns(){
        console.log("printing pronouns: ",this.pronouns);
        return this.pronouns;
    }

    getUsername(){
        console.log("printing username: ",this.username);
        return this.username;
    }

    async initialize() {
        await this.setProfilePicture();
        await this.setBackgroundPicture();
    }

    async setProfilePicture() {
        try {
            const fetchedProfilePicture = await fetchPFP(this.uid);
            if (fetchedProfilePicture) {
                this.profile_picture = fetchedProfilePicture;
                console.log("Profile picture fetched successfully:", this.profile_picture);
            } else {
                console.error("Failed to fetch profile picture");
            }
        } catch (error) {
            console.error("Error fetching profile picture:", error);
        }
    }
    async setBackgroundPicture(){
        try {
            const fetchedBackgroundPicture = await fetchBGP(this.uid);
            if (fetchedBackgroundPicture) {
                this.background_picture = fetchedBackgroundPicture;
                console.log("Profile picture fetched successfully:", this.background_picture);
            } else {
                console.error("Failed to fetch profile picture");
            }
        } catch (error) {
            console.error("Error fetching profile picture:", error);
        }
    }

    getProfilePicture() {
        console.log("Printing profile picture:", this.profile_picture);
        return this.profile_picture;
    }
    getBackgroundPicture() {
        console.log("Printing profile picture:", this.background_picture);
        return this.background_picture;
    }

    getFollowersCount(){
        console.log("Printing Followers count: ", this.followersCount);
        return this.followersCount;
    }
    getPronouns(){
        console.log("Printing pronouns: ", this.pronouns);
        return this.pronouns;
    }

    getFollowingCount(){
        console.log("Printing Followers count: ", this.followingCount);
        return this.followingCount;
    }

    getFollowers(){
        console.log("Printing Followers: ", this.followers);
        return this.followers;
    }

    getFollowing(){
        console.log("Printing Followers: ", this.following);
        return this.following;
    }
    getIsFollowing(){
        console.log("Printing isFollowing: ", this.isFollowing);
        return this.isFollowing;
    }
    

    setUserData = async() =>{
        try{
        const userRef = doc(db, 'users', this.uid);
        const docSnapshot = await getDoc(userRef);
        if (docSnapshot.exists()) {
            this.userData = docSnapshot.data();
            this.bio = docSnapshot.data().bio;
            this.genres = docSnapshot.data().genres;
            this.pronouns = docSnapshot.data().pronouns;
            this.username = docSnapshot.data().username;
            this.followers = docSnapshot.data().followers;
            this.following = docSnapshot.data().following;
            this.followersCount = this.userData.followers?.length || 0;
            this.followingCount = this.userData.following?.length || 0;
            this.isFollowing = this.userData.following?.includes(this.uid);
            //    userData.followers?.includes(currentUser.uid)
            console.log("user data fetched successfully");

        } 
    }
    catch (error) {
        console.error('Error fetching user data:', error);
    }

}
}